import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Handle from './handle';

import * as S from './styles';

export default class Handles extends Component {
  renderHandle(key) {
    return (
      <Handle
        key={`handle-${key}`}
        id={key}
        selected={this.props.selected && Boolean(this.props.selected[key])}
        positionData={this.props.positionData[key]}
        startDragging={this.props.startDragging}
        stopDragging={this.props.stopDragging}
        getSliderWidth={this.props.getSliderWidth}
        updateSlider={this.props.updateSlider}
        dragging={this.props.dragging}
      />
    );
  }

  render() {
    return (
      <S.Handles>{this.props.keys.map(this.renderHandle, this)}</S.Handles>
    );
  }
}

Handles.defaultProps = {
  selected: {
    from: false,
    to: false,
  },
};

Handles.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.shape({
    from: PropTypes.bool,
    to: PropTypes.bool,
  }),
  positionData: PropTypes.shape({
    from: PropTypes.shape({
      fill: PropTypes.number,
      position: PropTypes.number,
      section: PropTypes.number,
    }),
    to: PropTypes.shape({
      fill: PropTypes.number,
      position: PropTypes.number,
      section: PropTypes.number,
    }),
  }).isRequired,
  startDragging: PropTypes.func.isRequired,
  stopDragging: PropTypes.func.isRequired,
  getSliderWidth: PropTypes.func.isRequired,
  updateSlider: PropTypes.func.isRequired,
  dragging: PropTypes.bool.isRequired,
};
